export enum MeetingAttendanceMode {
    Virtual = 1,
    InPerson = 2,
}

export const MeetingAttendanceModeLabels: Record<MeetingAttendanceMode, string> = {
    [MeetingAttendanceMode.Virtual]: 'Virtually',
    [MeetingAttendanceMode.InPerson]: 'In-Person',
};
